import { Canceler } from 'axios'

export interface CancelerContainer {
    canceler?: Canceler
}

const cancelerContainerMap = new Map<string, CancelerContainer>()

function cancelLastHttpRequest(tokenName: string) {
    const lastContainer = cancelerContainerMap.get(tokenName)
    if (lastContainer !== undefined && lastContainer.canceler !== undefined) {
        lastContainer.canceler(`${tokenName} request cancelled`)
        cancelerContainerMap.delete(tokenName)
    }
}

function createNewCancelerContainer(tokenName: string): CancelerContainer {
    const cancelerContainer = {}
    cancelerContainerMap.set(tokenName, cancelerContainer)
    return cancelerContainer
}

export function getCancelerContainer(tokenName: string): CancelerContainer {
    cancelLastHttpRequest(tokenName)
    return createNewCancelerContainer(tokenName)
}
